const getInitialState = () => ({
  drill_tags: [],
})
const state = getInitialState()

const tags_conf = {
  endpoints: {
    drills: 'poker/practice/tags/',
    saved_filters: 'poker/saved-filters/tags/',
    saved_spots: 'poker/saved-spots/tags/',
    saved_trees: 'poker/custom-solutions/custom-trees/saved-trees/tags/',
    saved_ranges: 'poker/custom-solutions/custom-trees/saved-ranges/tags/',
    saved_solutions: 'poker/custom-solutions/user-solutions/tags/',
    custom_solutions: 'poker/custom-solutions/user-solutions/tags/', // the same as saved_solutions
    // hh_hands: 'poker/hand-history/tags/',
  },
  mutations: {
    drills: 'api_poker_drill_tags',
    saved_filters: 'api_poker_saved_filters_tags',
    saved_spots: 'api_poker_saved_spots_tags',
    saved_trees: 'api_poker_saved_trees_tags',
    saved_ranges: 'api_poker_saved_ranges_tags',
    saved_solutions: 'api_poker_saved_solutions_tags',
    custom_solutions: 'api_poker_custom_solutions_tags',
    // hh_hands: 'api_poker_hhands_tags',
  },
  actions: {
    drills: 'handleDrillTagsUpdate',
    saved_filters: 'handleSavedFiltersTagsUpdate',
    saved_spots: 'handleSavedSpotsTagsUpdate',
    saved_trees: 'handleSavedTreesTagsUpdate',
    saved_ranges: 'handleSavedRangesTagsUpdate',
    saved_solutions: 'handleSavedSolutionsTagsUpdate',
    custom_solutions: 'handleCustomSolutionsTagsUpdate',
    // hh_hands: 'handleHHandsTagsUpdate',
  },
  apiVersion: {
    drills: 'v1',
    saved_filters: 'v1',
    saved_spots: 'v1',
    saved_trees: 'v1',
    saved_ranges: 'v1',
    saved_solutions: 'v1',
    custom_solutions: 'v1',
    // hh_hands: 'v2',
  },
}

function getApiConf(tagType) {
  return {
    endpoint: tags_conf.endpoints[tagType],
    mutation: tags_conf.mutations[tagType],
    apiVersion: tags_conf.apiVersion[tagType],
    action: tags_conf.actions[tagType],
  }
}

const getters = {
  tags_get_all_tags: (state, getters, rootState, rootGetters) => tagType => {
    // console.log(getApiConf(tagType).mutation)
    // console.log(getters.api_get_data(getApiConf(tagType).mutation))
    if (!getApiConf(tagType).mutation) return null
    const res = getters.api_get_data(getApiConf(tagType).mutation) || []
    return res
  },
  get_tags_call: (state, getters, rootState, rootGetters) => tagType => {
    if (!getApiConf(tagType).mutation) return null
    const res = getters.api_get(getApiConf(tagType).mutation) || []
    return res
  },
}

const actions = {
  tags_get_tags({ state, commit, dispatch, getters }, { tagType = 'drills' }) {
    dispatch('api_tags_get_get', {
      method: 'GET',
      ...getApiConf(tagType),
    })
  },
  tags_set_tag(
    { state, commit, dispatch, getters },
    {
      item,
      method,
      hasMessage = true,
      hasExpectedResponse = false,
      tagType = 'drills',

      handleUpdateProps,
      // drills,
    },
  ) {
    if (hasExpectedResponse) {
      // used in toggling favorite
      const expectedResponse = { status: 200, data: item }
      if (tagType === 'drill') {
        dispatch('handleDrillTagsUpdate', {
          response: expectedResponse,
          method,
          item,
          hasMessage,
          hasExpectedResponse,
        })
      }
    }

    if (method === 'POST') {
      dispatch('api_tags_get_post', {
        method: 'POST',
        item,
        hasMessage,
        hasDataCheck: true,
        ...(handleUpdateProps || {}), // used in drills when adding tags to drills,
        ...getApiConf(tagType),
      })
    }
    if (method === 'PATCH') {
      dispatch('api_tags_get_patch', {
        method: 'PATCH',
        item,
        hasMessage,
        hasDataCheck: true,
        ...getApiConf(tagType),
      })
    }
    if (method === 'DELETE') {
      dispatch('api_tags_get_delete', {
        method: 'DELETE',
        item,
        hasMessage,
        hasDataCheck: true,
        ...getApiConf(tagType),
      })
    }
  },
  handleDrillTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, drills, hasMessage, hasDataCheck },
  ) {
    const status = response?.status
    let message = ''
    if (status === 201 || status === 200 || status === 204) {
      // console.log({ response, method, status })
      let res = getters.api_get_data('api_poker_drill_tags') || []
      const tag = response?.data
      if (method === 'POST') {
        res = [tag, ...res]
        message = 'success_drill_tag_create'

        if (drills) {
          const updatedItems = drills.map(d => ({
            ...d,
            tags: [tag, ...d.tags],
          }))
          dispatch('drills_set_drill', {
            items: updatedItems,
            hasMessage: false,
            method: 'PATCH',
            hasExpectedResponse: true,
            // namespace: this.namespace,
          })
        }
      } else if (method === 'PATCH') {
        res = res.map(i => (i.id === tag.id ? tag : i))
        message = 'success_tag_update'
      } else if (method === 'DELETE') {
        res = res.filter(i => i.id !== item.id)
        message = 'success_tag_delete'
      }

      if (
        !hasDataCheck &&
        JSON.stringify(res) === JSON.stringify(getters.api_get_data('api_poker_drill_tags'))
      ) {
        return
      }

      commit('api_update_data', { key: 'api_poker_drill_tags', data: res })
      // dispatch('router_reset_dialogs')

      if (hasMessage) {
        dispatch('tags_successMessage', { message })
      }
    } else if (error) {
      dispatch('tags_errorMessage', { message, method, error })
    }
  },
  // RF_TODO
  handleSavedFiltersTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_saved_filters_tags',
      table_mutation: 'api_poker_saved_filters',
    })
  },
  handleSavedSpotsTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_saved_spots_tags',
      table_mutation: 'api_poker_saved_spots_table',
    })
  },
  handleSavedTreesTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_saved_trees_tags',
      table_mutation: 'api_poker_saved_trees_table',
    })
  },
  handleSavedRangesTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_saved_ranges_tags',
      table_mutation: 'api_poker_saved_ranges_table',
    })
  },
  handleSavedSolutionsTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_saved_solutions_tags',
      table_mutation: 'api_poker_saved_solutions_table',
    })
  },
  handleCustomSolutionsTagsUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck },
  ) {
    dispatch('tags_handleUpdate', {
      response,
      error,
      method,
      item,
      hasMessage,
      hasDataCheck,
      tags_mutation: 'api_poker_custom_solutions_tags',
      table_mutation: 'api_poker_custom_solutions_table',
    })
  },

  tags_handleUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, item, hasMessage, hasDataCheck, tags_mutation, table_mutation },
  ) {
    const status = response?.status
    let message = ''
    if (status === 201 || status === 200 || status === 204) {
      // console.log({ response, method, status })
      let res = getters.api_get_data(tags_mutation) || []
      const tag = response?.data
      if (method === 'POST') {
        res = [tag, ...res]
        message = 'success_drill_tag_create'
      } else if (method === 'PATCH') {
        res = res.map(i => (i.id === tag.id ? tag : i))
        message = 'success_tag_update'
      } else if (method === 'DELETE') {
        res = res.filter(i => i.id !== item.id)
        message = 'success_tag_delete'
      }

      if (
        !hasDataCheck &&
        JSON.stringify(res) === JSON.stringify(getters.api_get_data(tags_mutation))
      ) {
        return
      }
      commit('api_update_data', {
        key: tags_mutation,
        data: res,
      })

      // update tags on table
      const allTags = res
      const apiData = getters.api_get_data(table_mutation)
      const results = (apiData.results || apiData || []).map(i => {
        let itemTags = i.tags.map(tt => allTags.find(t => t.id === tt.id))
        itemTags = itemTags.filter(t => t)
        return {
          ...i,
          tags: itemTags,
        }
      })
      commit('api_update_data', {
        key: table_mutation,
        data: !apiData.results ? results : { ...apiData, results },
      })

      // dispatch('router_reset_dialogs')
      if (hasMessage) {
        dispatch('tags_successMessage', { message })
      }
    } else if (error) {
      dispatch('tags_errorMessage', { message, method, error })
    }
  },
  tags_successMessage({ state, commit, dispatch, getters }, { message }) {
    dispatch('messages', {
      type: 'success',
      status: 'success_message',
      statusMessages: {
        _success_message: {
          i18n: `messages.${message}`,
          // i18nNum: responses.length,
        },
      },
      hide: true,
    })
  },
  tags_errorMessage({ state, commit, dispatch, getters }, { message, method, error }) {
    if (method === 'POST') {
      message = 'error_tag_create'
    } else if (method === 'PATCH') {
      message = 'error_tag_update'
    } else if (method === 'DELETE') {
      message = 'error_tag_delete'
    }
    const status = error?.response?.status || 'unknown'
    dispatch('messages', {
      type: 'error',
      status: 'err_message',
      statusMessages: {
        _err_message: {
          i18n: `messages.${message}`,
          i18nParams: { status },
          // i18nNum: errors.length,
        },
      },
    })
  },
}
const mutations = {
  drills_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  drills_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
